import React from 'react';

export default function PrivacyPolicy() {
    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            padding: '60px 20px',
            minHeight: '100vh',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        }}>
            <div style={{
                maxWidth: '900px',
                margin: '0 auto',
                backgroundColor: '#ffffff',
                padding: '40px 50px',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                color: '#333333'
            }}>
                <div style={{ borderBottom: '2px solid #eaeaea', paddingBottom: '20px', marginBottom: '30px' }}>
                    <h1 style={{ color: '#1a1a1a', fontSize: '2.5rem', marginBottom: '10px' }}>Privacy Policy</h1>
                    <p style={{ color: '#666', fontSize: '0.95rem' }}>Effective Date: July 23, 2026 | Kadtech HR Solutions</p>
                </div>
                
                <div style={{ lineHeight: '1.7', fontSize: '1rem', color: '#4a4a4a' }}>
                    <p style={{ marginBottom: '20px' }}>
                        At <strong>Kadtech HR Solutions</strong>, we value your trust and are deeply committed to safeguarding your privacy. This comprehensive Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you visit our website, register an account, upload your resume, or apply for employment opportunities through our platform.
                    </p>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>1. Information We Collect</h2>
                    <p style={{ marginBottom: '15px' }}>
                        We collect various types of information to provide and continuously improve our recruitment and HR services to you:
                    </p>
                    <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                        <li style={{ marginBottom: '10px' }}><strong>Personal Identification Information:</strong> Full name, email address, phone number, date of birth, gender, and residential/current address.</li>
                        <li style={{ marginBottom: '10px' }}><strong>Professional & Educational Data:</strong> Resumes, CVs, work experience history, job titles, educational qualifications, certifications, and skills.</li>
                        <li style={{ marginBottom: '10px' }}><strong>Account Credentials:</strong> Passwords and security tokens used for authentication on our platform.</li>
                        <li style={{ marginBottom: '10px' }}><strong>Technical Data:</strong> IP address, browser type, device information, operating system, and page interaction logs.</li>
                    </ul>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>2. How We Use Your Information</h2>
                    <p style={{ marginBottom: '15px' }}>
                        The data we collect is utilized strictly for professional and operational purposes, including:
                    </p>
                    <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                        <li style={{ marginBottom: '10px' }}>Facilitating job matching, applications, and connecting candidates with prospective employers.</li>
                        <li style={{ marginBottom: '10px' }}>Managing candidate profiles, processing profile updates, and sending relevant job alerts or notifications.</li>
                        <li style={{ marginBottom: '10px' }}>Enhancing platform security, preventing fraudulent activity, and troubleshooting technical issues.</li>
                        <li style={{ marginBottom: '10px' }}>Complying with statutory obligations, legal frameworks, and regulatory requirements.</li>
                    </ul>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>3. Data Security and Protection</h2>
                    <p style={{ marginBottom: '20px' }}>
                        We implement robust administrative, technical, and physical security measures—including data encryption, secure server architecture, and access control policies—to protect your personal information from unauthorized access, disclosure, alteration, or destruction.
                    </p>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>4. Contact Us</h2>
                    <p style={{ marginBottom: '10px' }}>
                        If you have any questions, concerns, or requests regarding this Privacy Policy, please reach out to us at:
                    </p>
                    <p style={{ fontWeight: '600', color: '#1a1a1a' }}>
                        Email: connect@kadtechhr.com <br />
                        Address: No. 11, 1st Floor, RT Nagar Main Road, Bangalore - 560032, Karnataka, India
                    </p>
                </div>
            </div>
        </div>
    );
}